/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPhone = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.854 15.676c.595.56 1.215 1.07 1.848 1.525l3.72-3.72 6.304.9v5.524l-.293.293c-2.193 2.193-6.265 1.685-10.225-.91a20.315 20.315 0 0 1-3.21-2.625 20.315 20.315 0 0 1-2.626-3.21C2.777 9.492 2.27 5.42 4.462 3.227l.293-.293h5.524l.9 6.303-3.72 3.72c.57.792 1.225 1.562 1.953 2.29zm3.585 2.617c2.615 1.412 4.996 1.656 6.287.738v-2.915l-3.597-.514zm-7.072-7.071L9.058 8.53l-.513-3.596H5.629c-.918 1.29-.674 3.671.738 6.287z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPhone as Phone };
